module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("SMS-påminnelse kunde:")]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sms_text),
      expression: "sms_text"
    }],
    attrs: {
      "placeholder": "Sms text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.sms_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sms_text = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.localErrors.sms_text) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.sms_text)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_number),
      expression: "phone_number"
    }],
    attrs: {
      "placeholder": "Phone number (12345678)",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone_number)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.localErrors.phone_number) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.phone_number)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send()
      }
    }
  }, [_vm._v("Send")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("textsms")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-252e2d0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/SmsDialog.vue
// module id = 107
// module chunks = 0